(function($){
	$(function(){

		var menuTimer = null;

		/*
		if (Modernizr.touch) {
			$('#header nav > ul > li > a').click(function(){
				var submenu = $(this).parent().find('ul');
				if (submenu.length && !submenu.is(':visible')) {
					$('#header nav ul ul').fadeOut();
					submenu.stop().fadeIn();
					return false;
				}
			});
		} else {
			$('#header nav > ul > li').mouseenter(function(){
				clearTimeout(menuTimer);
				$('#header nav ul ul').fadeOut();
				$(this).find('ul').stop().fadeIn();
			});
			$('#header nav > ul > li').mouseleave(function(){
				menuTimer = setTimeout(function(){
					$('#header nav ul ul').fadeOut();
				}, 500);
			});
		}
		*/

        if (!Modernizr.svg) {
            $('img[src*=".svg"]').each(function(){
				var fallback = $(this).attr('data-fallback');
				if (fallback) {
					$(this).attr('src', fallback);
				}
            });
        }

		// Sticky header
		$(window).scroll(function(){
			var width = $(window).width();
			if (width > 900) {
				if ($(document).scrollTop() > 31) {
					$('body').addClass('sticky-header');
				} else {
					$('body').removeClass('sticky-header');
				}
			}

		});

		$('body').click(function(e){
			if (!$(e.target).closest('#header nav').length) {
				$('#header nav ul ul').fadeOut();
			}
		});

		$('#header .toggle-menu').click(function(){
			$(this).toggleClass('active');
			$('body').toggleClass('mobile-menu');
			$('#header .links .cart .menu').hide();
			$('#header .search-bar').hide();
			return false;
		});

		$('#header .links .search a').click(function(){
			$('body').removeClass('mobile-menu');
			$('#header .toggle-menu').removeClass('active');
			$('#header .links .cart .menu').hide();
			$('#header .search-bar').toggle();
			$('#header .search-bar [name="q"]').get(0).focus();
			$('#nav-mask').stop().fadeOut(200);
			return false;
		});

		$('#header .links .cart > a').click(function(){
			var w = $('body').width();
			if (w > 900) return true;
			$('body').removeClass('mobile-menu');
			$('#header .toggle-menu').removeClass('active');
			$('#header .search-bar').hide();
			$('#header .links .cart .menu').toggle();
			return false;
		});

		$('#hero').flexslider({
			slideshow: true,
			controlNav: false,
			directionNav: false,
			slideshowSpeed: 7000,
			animationSpeed: 1500
		});

		$('#hero a.next').click(function(){
			$('#hero').flexslider('next');
			return false;
		});

		$('.search-bar [type="text"]').keyup(function(){
			var s = $(this).val();
			if (s.length) {
				$(this).parent().find('.clear-text').show();
			} else {
				$(this).parent().find('.clear-text').hide();
			}
		});

		$('.search-bar .clear-text').click(function(){
			$(this).parent().find('[type="text"]').val('').get(0).focus();
			$(this).hide();
			return false;
		});

		$('.search-bar [type="text"]').trigger('keyup');

		$('.subnav > li > a').click(function(){
			if ($(this).parents('aside').length > 0) return;
			if ($(this).parent().find('ul').length) {
				if (!$(this).parent().find('ul').is(':visible')) {
					$('#mobile-menu .subnav .expanded').removeClass('expanded');
					$('#mobile-menu .subnav ul').slideUp();
					$(this).parent().addClass('expanded').find('ul').stop().slideDown(500, function(){
						$('body').trigger('sticky_kit:recalc');
					});
					return false;
				}
			}
		});

		$('#mobile-menu .panel-tabs a').click(function(){
			var panel = $(this).attr('data-panel');
			$('#mobile-menu .panel').hide();
			$('#mobile-menu .panel-tabs li').removeClass('active');
			$(this).parent().addClass('active');
			$('#mobile-menu .panel.' + panel).show();
			return false;
		});

		// Thanks to CSS-Tricks.com for the snippet
		// https://css-tricks.com/snippets/jquery/smooth-scrolling/
		/*
		$(function() {
			$('a[href*=#]:not([href=#])').click(function() {
				if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
					var target = $(this.hash);
					target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
					if (target.length) {
						$('html,body').animate({
							scrollTop: target.offset().top - 110
						}, 1000, 'easeOutExpo');
						location.hash = this.hash;
						return false;
					}
				}
			});
		});
		*/

		$('.featured-items-slider').slick({
			infinite: true,
			prevArrow: false,
			nextArrow: '<button class="next"><span class="fa fa-chevron-right"></span></button>',
			speed: 750,
			slidesToShow: 4,
			slidesToScroll: 4,
			responsive: [
				{
					breakpoint: 901,
					settings: {
						slidesToShow: 3,
						slidesToScroll: 3
					}
				},
				{
					breakpoint: 650,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 2
					}
				},
				{
					breakpoint: 500,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1
					}
				}
			]
		});

		$('.drilldown').drilldown({
			speed: 250,
			selector: '.drilldown-link'
		});

		$('#header .links').superfish({
			popUpSelector: '.menu',
			delay: 400,
			onInit: function(){
				$('#header .links .cart .menu').hide();
			},
			onBeforeShow: function(){
				var w = $(window).width();
				if (w < 901) return false;
				$('#nav-mask').stop().fadeIn(200);
			},
			onBeforeHide: function(){
				var w = $(window).width();
				if (w < 901) return false;
				$('#nav-mask').stop().fadeOut(200);
			}
		});

		$('#main.left-sidebar-layout > div > aside').stick_in_parent({
			offset_top: 61
		});

		$('#product-detail .photos .large').flexslider({
			slideshow: false,
			controlNav: false,
			directionNav: false,
			slideshowSpeed: 5000,
			animationSpeed: 1500,
			before: function(slider){
				slider.find('video').each(function(){ if (!this.paused) this.pause(); });
				slider.find('iframe').each(function(){
					var original = $(this).data('original-src');
					this.src = original || this.src;
				});
			}
		});

		/*
		$('#product .photos .thumbs').flexslider({
			slideshow: false,
			controlNav: false,
			directionNav: false,
			slideshowSpeed: 5000,
			animationSpeed: 1500,
			asNavFor: '#product .photos .large'
		});
		*/
		$('#product-detail .photos .thumbs a').each(function(index){
			$(this).click(function(){
				$('#product-detail .photos .thumbs li').removeClass('active').eq(index).addClass('active');
				$('#product-detail .photos .large').data('flexslider').flexAnimate(index, true);

				var $slide = $('#product-detail .photos .large .slides > li').eq(index);
				var mediaType = $slide.data('media-type');
				if (mediaType === 'video') {
					var video = $slide.find('video').get(0);
					if (video) {
						var playPromise = video.play();
						if (playPromise && playPromise.catch) playPromise.catch(function(){});
					}
				} else if (mediaType === 'external_video') {
					var $iframe = $slide.find('iframe').first();
					var iframe = $iframe.get(0);
					if (iframe) {
						if (!$iframe.data('original-src')) $iframe.data('original-src', iframe.src);
						var src = $iframe.data('original-src');
						var sep = src.indexOf('?') === -1 ? '?' : '&';
						var params = src.indexOf('vimeo') !== -1 ? 'autoplay=1&muted=1' : 'autoplay=1&mute=1';
						iframe.src = src + sep + params;
					}
				}

				return false;
			});
		});

		$('ul.panels > li > a').click(function(){
			$(this).parents('li').toggleClass('expanded').find('.content').slideToggle();
			return false;
		});

		$('body').on('click', '#product-detail a.pr-snippet-link', function(){
			$.scrollTo('#product-reviews', 1000, {easing: 'easeOutExpo', offset: -100});
			return false;
		});

		$('body').on('click', '#product-detail .pr-nav-back-to-top a', function(){
			$.scrollTo('#top', 1000, {easing: 'easeOutExpo'});
			return false;
		});

		$('#footer form.newsletter-signup').submit(function(){
			if ($(this).find('[name="email"]').val().trim().length < 1) {
				alert('Please enter an email address.');
				return false;
			}
			$('#footer .newsletter').addClass('loading-mask');
			$.post($(this).attr('action'), $(this).serialize(), function(){
				$('#footer .newsletter').removeClass('loading-mask');
				$('#footer form.newsletter-signup').hide();
				$('#footer .newsletter .message').show();
			});
			return false;
		});

		/**
		 * OSC
		 */
		$('.module-options .head').click(function(){
			//if ($(this).find('[type="radio"]').prop('checked') == false) {
				$(this).find('[type="radio"]').prop('checked', true).trigger('change');
			//}
		});

		$('.module-options [type="radio"]').change(function(){
			$(this).parents('.module-options').find('.option').removeClass('active');
			$(this).parents('.module-options').find('[type="radio"]:checked').parents('.option').addClass('active');
			//$(this).parents('.option').addClass('active');
		});

		$('a[href*="popup"], a.popup').click(function(){
			popupWindow($(this).attr('href'));
			return false;
		});

		$('#main').fitVids();

		$('#product-reviews .toggle-reviews a').click(function(){
			$('#product-reviews .pr-review-sort').slideToggle();
			$('#product-reviews .pr-contents').slideToggle();
			if ($(this).text() == 'Show Reviews') {
				$(this).text('Hide Reviews');
			} else {
				$(this).text('Show Reviews');
			}
			return false;
		});

		$('.content-search-results a.view-more').click(function(){
			$(this).hide();
			$(this).next('.more').show();
			return false;
		});

		$('select.state-selector').each(function(){
			var $country = $('#' + $(this).attr('data-country-controller-id'));
			var $state = $(this);

			if ($country) {
				$country.change(function(){
					var countryId = $(this).val();

					$state.find('option').not('.placeholder').hide();
					$state.find('[data-country-id="' + countryId + '"]').show();

					if (countryId == 223) {
						$state.find('option.placeholder').text('Please choose state... *');
					} else {
						$state.find('option.placeholder').text('Please choose province... *');
					}
				});

				$country.trigger('change');
			}
		});
	});
})(jQuery);

function popupWindow(url) {

	$ = jQuery;

	$('#popup-dialog').addClass('loading-mask');

	$.get(url + ' #content', function(data){
		$('#popup-dialog .content').html(data);
		$('#popup-dialog').removeClass('loading-mask');
	});

	$.magnificPopup.open({
		items: {
			src: '#popup-dialog',
			type: 'inline'
		},
		closeOnBgClick: true,
		closeOnContentClick: false
	});

	return false;

}

// Trap focus
function trapFocus( element, focusElement ) {
    var focusableEls        = element.querySelectorAll( 'a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled])' );
    var firstFocusableEl    = focusableEls[0];  
    var lastFocusableEl     = focusableEls[focusableEls.length - 1];
    var KEYCODE_TAB         = 9;

	function listener( e ) {
        var isTabPressed = ( e.key === 'Tab' || e.keyCode === KEYCODE_TAB );

        if ( ! isTabPressed ) { 
            return; 
        }

        if ( e.shiftKey ) {
            // shift + tab
            if ( document.activeElement === firstFocusableEl ) {
                lastFocusableEl.focus();
                e.preventDefault();
            }
        } else {
            // tab
            if ( document.activeElement === lastFocusableEl ) {
                firstFocusableEl.focus();
                e.preventDefault();
            }
        }
    };

    element.addEventListener( 'keydown', listener );

    if ( focusElement ) {
        setTimeout( function() {
            focusElement.focus();
        }, 50 );
    } else {
		firstFocusableEl.focus();
	};

	return () => {
		element.removeEventListener( 'keydown', listener );
	}
}